import { render } from "./StarTabBar.vue?vue&type=template&id=5bf4e00c&scoped=true&ts=true"
import script from "./StarTabBar.vue?vue&type=script&lang=ts"
export * from "./StarTabBar.vue?vue&type=script&lang=ts"

import "./StarTabBar.vue?vue&type=style&index=0&id=5bf4e00c&scoped=true&lang=css"
import "./StarTabBar.vue?vue&type=style&index=1&id=5bf4e00c&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf4e00c"]])

export default __exports__